import { LabRowData } from "../../tables/lab/lab-rows";
import { ObservationSeries } from "../../table-transforms/series-utils";
import { FeaturedCategory } from "../categories";
import { TableRow } from "../../utils/tables-metadata";

/**
 * LOINC codes for depression screening observations
 */
const DEPRESSION_SCREENING_LOINC_CODES = [
  "44249-1", // PHQ-9 (Patient Health Questionnaire-9) total score
  "55758-7", // PHQ-2 (Patient Health Questionnaire-2) total score
  "89204-2", // PHQ-9 quick depression assessment panel
  "44261-6", // Patient Health Questionnaire 2 item (PHQ-2) [Reported]
  "73831-0", // Geriatric Depression Scale (GDS)
  "89210-9", // Edinburgh Postnatal Depression Scale (EPDS)
];

/**
 * LOINC codes for cognitive impairment screening observations
 */
const COGNITIVE_IMPAIRMENT_SCREENING_LOINC_CODES = [
  "72106-8", // Mini-Mental State Examination (MMSE)
  "72172-0", // Montreal Cognitive Assessment (MoCA)
  "72173-8", // Brief Interview for Mental Status (BIMS)
  "52491-8", // Mini-Cog
  "71492-3", // Cognitive Function
  "86585-7", // Signs and symptoms of cognitive decline or impairment
];

/**
 * Filter depression screening observations for Featured section
 */
export function getDepressionScreenings(observations: LabRowData[]): LabRowData[] {
  return observations.filter(obs => {
    const series = obs.originalData as ObservationSeries;
    const code = series.code;
    return DEPRESSION_SCREENING_LOINC_CODES.some(loincCode => code.includes(loincCode));
  });
}

/**
 * Filter cognitive impairment screening observations for Featured section
 */
export function getCognitiveImpairmentScreenings(observations: LabRowData[]): LabRowData[] {
  return observations.filter(obs => {
    const series = obs.originalData as ObservationSeries;
    const code = series.code;
    return COGNITIVE_IMPAIRMENT_SCREENING_LOINC_CODES.some(loincCode => code.includes(loincCode));
  });
}

export function getFeaturedScreenings(): FeaturedCategory {
  return {
    category: "Screenings",
    subCategories: [
      {
        subCategory: "Depression Screening",
        tableType: "LaboratoryObservations",
        getRows: (data: TableRow[]) => getDepressionScreenings(data as LabRowData[]),
      },
      {
        subCategory: "Cognitive Impairment Screening",
        tableType: "LaboratoryObservations",
        getRows: (data: TableRow[]) => getCognitiveImpairmentScreenings(data as LabRowData[]),
      },
    ],
  };
}
